import React, { useEffect } from 'react';
import { useStore } from '../../../../stores/root';
import { DatePicker, Dropdown, Stack } from '@fluentui/react';
import moment from 'moment';
import { IOutcomeResourceShorterProps } from '../../../../props/finance/outcomes';
import GeneralService from '../../../../services/general';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IncomesSummaryFilter, { IncomesSummaryFilterData } from './filters';
import IncomesSummaryCard from './cards';
import DetailsStack, { IStackDefaultSectionProps } from '../../../uiframeworks/detailsStack';
import IncomesSummaryInvoices from './pivots/invoices';
import IncomePaymentsList from '../payments/general/list';

// assets

// services

// props

// components

type IncomesSummaryProps = {
}



const IncomesSummary: React.FC<IncomesSummaryProps> = (props: IncomesSummaryProps) => {
    const { banner, user } = useStore();

    const [filter, setFilter] = React.useState<IncomesSummaryFilterData>({
        startDate: moment().startOf('week').toISOString(),
        endDate: moment().endOf('week').toISOString()
    });

    useEffect(() => {

    }, []);

    const renderPivots = (): IStackDefaultSectionProps[] => {
        return [{
            key: 'pivots',
            tabs: [
                {
                    key: 'unpaidInvoices',
                    title: "Unpaid Invoices",
                    content: <IncomesSummaryInvoices />
                },
                {
                    key: 'pendingPayments',
                    title: "Pending Payments",
                    content: <IncomePaymentsList qs={['status=Pending;FinanceConfirmed', 'order_by=payment_date', 'order_by_direction=ASC']} />
                }
            ],
            isCard: true
        }]
    }

    return <Stack styles={{root: {width: '100%'}}} tokens={{childrenGap: 20}}>
        <IncomesSummaryFilter selected={filter} onChange={(f) => setFilter(f)} />
        <IncomesSummaryCard />
        <DetailsStack left={renderPivots()} />
    </Stack>;
};

export default IncomesSummary;
